import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { AthenaSyncData } from '../mockData/athena-sync-data';

const AthenaPatientSyncApi = [
  rest.post(`${API_ROOT}athena-patient-sync`, (req, res, ctx) => res(ctx.json(AthenaSyncData))),
  rest.delete(`${API_ROOT}athena-patient-sync`, (req, res, ctx) => res(ctx.json({ success: true }))),
];
export default AthenaPatientSyncApi;
